// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

// The asset summary is the only message still delivered by email, so it is the
// only thing an organization can point at a custom address. Every other digest
// topic was retired with the code that sent it.
//
// The shipment messages the inbox raises are not here: they are read in the
// app, and the subscription screen reads them from the catalog endpoint rather
// than from a list the frontend keeps of its own.
export const messageTypeSchema = caseInsensitiveEnum(['ASSET_SUMMARY']);

export const MESSAGE_TYPES = messageTypeSchema.options;

export type MessageType = z.infer<typeof messageTypeSchema>;

export const MESSAGE_TYPE_LABELS: Record<MessageType, string> = {
  ASSET_SUMMARY: 'Asset summary',
};

export const MESSAGE_TYPE_DESCRIPTIONS: Record<MessageType, string> = {
  ASSET_SUMMARY: 'Get a weekly report on the status of your asset fleet',
};
